import { createBreakpoints } from '@mui/system';
import { Breakpoints } from '@mui/system/createTheme/createTheme';

const breakpointsOption = {
    values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1600,
    },
};

const breakpoints: Breakpoints = createBreakpoints(breakpointsOption);

export { breakpointsOption, breakpoints };
